export default __webpack_public_path__ + "static/LFS_INFO_V2-a695138152ddcd70074b3d8b57048ab4.jpg";